import { Types } from '../../components/config/actionTypes';


function setIpInfo(ipInfoDetails) {
    return dispatch => {


        dispatch({ 
            type : Types.IP_INFO_DETAILS, 
            payload : { ipInfoDetails : ipInfoDetails }
        });
    }

}

function removeIpInfo() {
    return dispatch => {
        // localStorage.removeItem('ipInfoDetails');
        dispatch({ 
            type: Types.REMOVE_IP_INFO_DETAILS, 
            payload : { ipInfoDetails : null}
        });
    }
}

export const ipInfoActions = {
    setIpInfo,
    removeIpInfo
};